import React, { useEffect, useState } from 'react';
import DocumentMeta from 'react-document-meta';
import { sendEvent } from 'shared/helpers/requests';
import { fetchPaymentData } from 'shared/api/fetchPaymentData';
import { fetchHasPremium } from 'shared/api/fetchPremiumData';
import { FirstBlock } from './components/FirstBlock';
import { SecondBlock } from './components/SecondBlock';
import { ThirdBlock } from './components/ThirdBlock';
import { FourthBlock } from './components/FourthBlock';
import { FifthBlock } from './components/FifthBlock';
import { ReactComponent as FooterLogo } from './images/logo_footer.svg';
import styles from './OneToManySubscription.module.scss';

export const PRODUCT_NAME = 'student_webinars';

export function OneToManySubscription({ afterWebUrl }: { afterWebUrl?: boolean }) {
  const afterWebTimestamp = 1778598000000; // 12 мая 15:00

  const [isAfterBuy, setIsAfterBuy] = useState(false);

  const isAfterWeb = Date.now() > afterWebTimestamp;
  const [isLoaded, setIsLoaded] = useState(false);

  const goToUchiMain = () => {
    window.location.assign(`https://uchi.ru/`);
  };

  const goToPayment = () => {
    goToUchiMain();
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const hasPremium = await fetchHasPremium(PRODUCT_NAME);
        setIsAfterBuy(hasPremium);

        setIsLoaded(true);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('error:', error);
        setIsLoaded(true);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    if (!isLoaded) return;
    if (!isAfterWeb && !isAfterBuy) {
      sendEvent({
        eventType: 'visit_reg',
        eventSource: 'pryamyye_efiry_kak_kopit',
        eventInfo: '',
      });
    }
    if (isAfterWeb && !isAfterBuy) {
      sendEvent({
        eventType: 'visit_after_vebinar',
        eventSource: 'pryamyye_efiry_kak_kopit',
        eventInfo: JSON.stringify({ from: afterWebUrl ? 'vebinar' : 'lk' }),
      });
    }
    if (isAfterBuy) {
      sendEvent({
        eventType: 'visit_after_payment',
        eventSource: 'pryamyye_efiry_kak_kopit',
        eventInfo: '',
      });
    }
  }, [isAfterWeb, isAfterBuy, isLoaded, afterWebUrl]);

  if (!isLoaded) return null;

  return (
    <div className={styles.root}>
      <DocumentMeta title="Прямые эфиры для начальной школы | Учи.ру" />
      <FirstBlock isAfterBuy={isAfterBuy} goToUchiMain={goToUchiMain} goToPayment={goToPayment} />
      <SecondBlock />
      <ThirdBlock isAfterBuy={isAfterBuy} goToPayment={goToPayment} />
      <FourthBlock />
      <FifthBlock isAfterBuy={isAfterBuy} goToPayment={goToPayment} />
      <footer className={styles.footer}>
        <FooterLogo className={styles.logo} onClick={goToUchiMain} />
      </footer>
    </div>
  );
}
